import { Axios } from '@src/app/context/Api/includes/Axios';
import { EventSchema } from '@src/entities/Event/includes/schemas';
import { EventEntity } from '@src/entities/Event/includes/types';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { AxiosHeaders, AxiosRequestConfig, AxiosResponse } from 'axios';
import { isEmpty, isUndefined, omit } from 'lodash';

import { SaveEventSchema } from './includes/schema';
import { SaveEventMutationPayload } from './includes/types';

interface CustomRequestHeaders extends AxiosHeaders {
  'x-api-endpoint': string;
}

/**
 * Mutation: SaveEvent
 *
 * Saves a single event with the remote API via an authenticated request.
 */
export const SaveEvent = async (payload: SaveEventMutationPayload = ['Event', 'SaveEvent']): Promise<EventEntity> => {
  try {
    const [theApiKey, theMutationKey, thePayload] = payload;

    const body = omit(thePayload, ['id']);

    const requestArgs: AxiosRequestConfig = {
      baseURL: config('API_URL'),
      data: body,
      headers: { 'x-api-endpoint': '/events' } as CustomRequestHeaders,
      method: 'POST',
      params: { apiKey: theApiKey, mutationKey: theMutationKey },
    };

    if (!isUndefined(thePayload?.eventId) && !isEmpty(thePayload?.eventId)) {
      requestArgs.headers = { 'x-api-endpoint': `/events/${thePayload?.eventId}` } as CustomRequestHeaders;
      requestArgs.method = 'PUT';
    }

    SaveEventSchema.parse(body);

    const remoteResponse: AxiosResponse = await Axios.request(requestArgs);
    return EventSchema.parse(remoteResponse.data);
  } catch (error) {
    logger.error('src/entities/Event/api/requests/mutations/SaveEvent/SaveEvent.ts -> SaveEvent()', false, error);
    throw error;
  }
};
